import AuthRegLayout from '@/apps/layout/components/AuthRegLayout'
import ResetPassword from '@/apps/ResetPassword'
import React from 'react'

const ResetPasswordPage = (): React.ReactElement => {
  return (
    <AuthRegLayout>
      <ResetPassword />
    </AuthRegLayout>
  )
}

export default ResetPasswordPage
